export default {"src":"/_next/static/media/WAFD.9cade967.svg","height":18,"width":18};